import { Injectable } from '@angular/core';
import { AppConfig } from '../models/app-config.model';

declare global {
  interface Window {
    GCM_APP_CONFIG: AppConfig;
  }
}

@Injectable({
  providedIn: 'root'
})
export class RuntimeConfigService {
  private _config!: AppConfig;

  constructor() {
    this._config = window.GCM_APP_CONFIG;
  }

  getConfig(): AppConfig {
    return this._config;
  }
}